import UserProfile from '../Auth/UserProfile'
import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import { useForm } from 'react-hook-form';
import APIS from '../../constant/EndPoint';
import { merchantDeliveryChargeTemplateValidationForm } from '../../utils/validationSchema';
import ComboboxInput from '../Reusable/Form/ComboboxInput';
import Form from '../../layouts/Form';
import TextField from '../Reusable/Form/TextInput';
import MultipleSelectField from '../Reusable/Form/MultipleSelectField';
import Card from '../Reusable/Card';
import DeliveryChargeTable from './DeliveryChargeTable';
import APIIntegration from './APIIntegration';

const EditMerchant = (props: any) => {
  const { profile, isLoading, handleEdit } = props
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    setError,
    getValues,
    watch,
    clearErrors
  } = useForm<any>({
    resolver: yupResolver(merchantDeliveryChargeTemplateValidationForm),
    defaultValues: async () => {
      // let data: any = await props?.refetch()
      return {
        delivery_charge_template: profile?.delivery_charge_template,
        vat_pan: profile?.vat_pan,
        product_type: profile?.product_type?.map((item: any, index: number) => ({ label: item?.name, value: item?.id })),
        service_type: profile?.service_type?.map((item: any, index: number) => ({ label: item?.name, value: item?.id })),
        service_city: profile?.service_city?.map((item: any, index: number) => ({ label: item?.name, value: item?.id })),
        service_branch: profile?.service_branch?.map((item: any, index: number) => ({ label: item?.name, value: item?.id })),
      }
    }
  });

  const localServiceBranch = watch("local_branch")
  const localServiceType = watch("local_service")






  return (
    <>
      <UserProfile
        profile={profile}
      />
      <APIIntegration/>
      <Form
        handleSubmit={handleSubmit}
        handleFormSubmit={handleEdit}
        setError={setError}
        buttonLabel={"Update"}
        isLoading={isLoading}
      >
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 mx-4">
          <TextField
            label={"PAN/VAT"}
            register={register("vat_pan")}
            errors={errors?.vat_pan}
          />
          <MultipleSelectField
            queryKey={"service-type"}
            label={"Service Type"}
            register={register("service_type")}
            watch={watch}
            setValue={setValue}
            url={APIS.SERVICE_TYPE}
            value={profile?.service_type?.map((item: any, index: number) => ({ label: item?.name, value: item?.id }))}
          />
          <MultipleSelectField
            label={"Product Type"}
            queryKey={"product-type"}
            register={register("product_type")}
            watch={watch}
            setValue={setValue}
            url={APIS.PRODUCT_TYPE}
            value={profile?.product_type?.map((item: any, index: number) => ({ label: item?.name, value: item?.id }))}
          />
          <MultipleSelectField
            label={"Service Branch"}
            queryKey={"service-branch"}

            register={register("service_branch")}
            watch={watch}
            setValue={setValue}
            url={APIS.BRANCH}
            value={profile?.service_branch?.map((item: any, index: number) => ({ label: item?.name, value: item?.id }))}
          />
          <MultipleSelectField
            label={"Service City"}
            queryKey={"service-city"}
            register={register("service_city")}
            watch={watch}
            setValue={setValue}
            url={`${APIS.LOCATION}flat-location/`}
            value={profile?.service_city?.map((item: any, index: number) => ({ label: item?.name, value: item?.id }))}
            props={{
              level: 3
            }}
          />
          <ComboboxInput
            url={APIS.DELIVERY_CHARGE_TEMPLATE}
            props={{}}
            queryKey={"delivery-charge-template"}
            register={register("delivery_charge_template")}
            errors={errors?.parent}
            name={"delivery_charge_template"}
            label={"Delivery Charge Template"}
            setValue={setValue}
            placeholder={"Search Delivery Charge Template"}
            getValues={getValues}
            clearErrors={clearErrors}
          />
        </div>
      </Form>
      <Card title={`Rate List`}>
        <div className='w-full grid grid-cols-2 gap-x-6'>
          <ComboboxInput
            url={APIS.BRANCH}
            props={{ "merchant_service_branch": profile?.id }}
            queryKey={"local-branch"}
            register={register("local_branch")}
            errors={errors?.local_branch}
            name={"local_branch"}
            label={"Service Branch"}
            setValue={setValue}
            placeholder={"Branch"}
            getValues={getValues}
            clearErrors={clearErrors}
          />
          <ComboboxInput
            url={APIS.SERVICE_TYPE}
            props={{ "merchant_service_types": profile?.id }}
            queryKey={"local-service"}
            register={register("local_service")}
            errors={errors?.local_branch}
            name={"local_service"}
            label={"Service Type"}
            setValue={setValue}
            placeholder={"Service Type"}
            getValues={getValues}
            clearErrors={clearErrors}
          />
        </div>
      </Card >
      <Card title={`Rate Format`}>
        {localServiceBranch && localServiceType ?
          <DeliveryChargeTable localServiceBranch={localServiceBranch} localServiceType={localServiceType} merchantId={profile?.id} />
          : <> <p>Please select Service Branch And Service type</p>
          </>
        }
      </Card>
    </>
  )
}

export default EditMerchant
